// extracted by mini-css-extract-plugin
export default {"svg":"RedirectNode_svg__v5NWa","placeholder":"RedirectNode_placeholder__usbag","deleteIcon":"RedirectNode_deleteIcon__bIalr"};